<template>
    <b-form-group :label="label" label-for="level">
        <Select
            id="level"
            :state="state"
            :selected="value"
            :options="levelOptions"
            @changeValue="
                event => {
                    $emit('change', event)
                    $emit('update:value', event)
                }
            "
            aria-describedby="level-feedback"
            :disabled="disabled"
        />
        <b-form-invalid-feedback id="level-feedback">
            <slot />
        </b-form-invalid-feedback>
    </b-form-group>
</template>

<script>
import { Select } from '@/views/components/selects'
import defaultLevelOptions from '@/data/level'

export default {
    name: 'Level',
    components: {
        Select,
    },
    props: [
        'value',
        'state',
        'disabled',
        'label',
        'isEditing',
        'allowedLevels',
        'isLibraryTarget',
    ],
    mounted() {
        if (!this.isEditing && this.allowedLevels.personal.create) {
            this.setDefaultValue(this.levelOptions)
        }
    },
    methods: {
        setDefaultValue(levels) {
            const defaultLevel = levels.find(level => level.isDefault)
            this.$emit('update:value', defaultLevel)
        },
        filterOptionsByLibraryTarget() {
            const operation = 'create_library_goal'
            return defaultLevelOptions.filter(option => {
                const { value } = option
                return this.allowedLevels[value][operation]
            })
        },
        filterOptionsByCreateOrEdit() {
            let operation = 'create'
            if (this.isEditing) {
                operation = 'edit'
            }
            return defaultLevelOptions.filter(option => {
                const { value } = option
                return this.allowedLevels[value][operation]
            })
        },
    },
    computed: {
        levelOptions() {
            if (this.isLibraryTarget) {
                return this.filterOptionsByLibraryTarget()
            } else {
                return this.filterOptionsByCreateOrEdit()
            }
        },
    },
}
</script>
